import { render, staticRenderFns } from "./StartPage.vue?vue&type=template&id=60fef4fc&scoped=true&"
import script from "./StartPage.vue?vue&type=script&lang=ts&"
export * from "./StartPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fef4fc",
  null
  
)

export default component.exports